function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcnTobaccostick({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 138",
    d: "m24.76 23.41.06-.14a7.87 7.87 0 0 0 .78-3.41 8.1 8.1 0 0 0-.66-3.16l-.06-.13h8.27a1.36 1.36 0 0 1 1.1.52A5.08 5.08 0 0 1 35.1 20a4.92 4.92 0 0 1-.94 3 1.28 1.28 0 0 1-1 .48zm-12.07 0 .11-.15a5.77 5.77 0 0 0 .9-3.26 5.83 5.83 0 0 0-.92-3.29l-.1-.15h11.19v.05a7 7 0 0 1-.14 6.74v.05h-.05zm-4.47 0 .11-.16a5.76 5.76 0 0 0 .9-3.25 5.68 5.68 0 0 0-.91-3.27l-.1-.16h2.87c.82 0 1.71 1.37 1.71 3.43s-.86 3.35-1.66 3.41zm-1.59 0c-.85 0-1.73-1.39-1.73-3.42s.89-3.43 1.72-3.43S8.33 18 8.33 20s-.88 3.41-1.7 3.42m17.46-7.78H6.62C5.14 15.7 4 17.6 4 20s1.15 4.34 2.62 4.34h26.5a2.16 2.16 0 0 0 1.75-.83A5.77 5.77 0 0 0 36 19.94a6 6 0 0 0-1-3.39 2.25 2.25 0 0 0-1.83-.9h-9.08",
    style: {
      fill: "#5e5e5d"
    }
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnTobaccostick);
export default __webpack_public_path__ + "static/media/icn-tobaccostick.f9ab469df27cb5577180250f13ec9543.svg";
export { ForwardRef as ReactComponent };